import StaticHeader from './StaticHeader';

export default StaticHeader;
